
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "MedicalOrganization",
      "name": "Thorn Ford Dental Laboratory",
      "description": "Precision dental manufacturing of crowns, bridges, implants, and dental prosthetics since 1977",
      "url": siteUrl,
      "logo": `${siteUrl}/favicon.jpeg`,
      "foundingDate": "1977",
      "medicalSpecialty": "Dentistry",
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "email": "admin@thornford.com"
      }
    };

    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Thorn Ford Dental Laboratory | Precision Dental Manufacturing Since 1977",
      "description": "Thorn Ford Dental Laboratory providing precision manufacturing of crowns, bridges, implants, and dental prosthetics. Serving dentistry since 1977 with exceptional quality.",
      "url": siteUrl,
      "publisher": {
        "@type": "Organization",
        "name": "Thorn Ford Dental Laboratory"
      }
    };

    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Dental Laboratory Services",
      "provider": {
        "@type": "Organization",
        "name": "Thorn Ford Dental Laboratory"
      },
      "areaServed": "Worldwide",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Dental Laboratory Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Crowns & Bridges",
              "description": "Custom-crafted crowns and bridges with precision fit and natural aesthetics"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Implant Solutions",
              "description": "Complete implant restorations from single units to full-arch rehabilitations"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Removable Prosthetics",
              "description": "Comfortable and functional dentures, partials, and flexible prosthetics"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Digital Dentistry",
              "description": "Advanced CAD/CAM technology for precise digital workflows"
            }
          }
        ]
      }
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(webPageSchema);
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(serviceSchema);
    document.head.appendChild(script3);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
